import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import axios from 'axios';
import io from 'socket.io-client';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://api.nurradyo.com';
const API_URL = `${BASE_URL}/api`;

// Önceden tanımlı sosyal medya iconları (renkli SVG)
const PREDEFINED_ICONS = [
  { id: 'youtube', name: 'YouTube', color: '#FF0000', svg: '<svg viewBox="0 0 24 24" fill="#FF0000"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>' },
  { id: 'instagram', name: 'Instagram', color: '#E4405F', svg: '<svg viewBox="0 0 24 24" fill="#E4405F"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/></svg>' },
  { id: 'facebook', name: 'Facebook', color: '#1877F2', svg: '<svg viewBox="0 0 24 24" fill="#1877F2"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>' },
  { id: 'twitter', name: 'X (Twitter)', color: '#000000', svg: '<svg viewBox="0 0 24 24" fill="#000000"><path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"/></svg>' },
  { id: 'tiktok', name: 'TikTok', color: '#000000', svg: '<svg viewBox="0 0 24 24" fill="#000000"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg>' },
  { id: 'telegram', name: 'Telegram', color: '#26A5E4', svg: '<svg viewBox="0 0 24 24" fill="#26A5E4"><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>' },
  { id: 'whatsapp', name: 'WhatsApp', color: '#25D366', svg: '<svg viewBox="0 0 24 24" fill="#25D366"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>' },
  { id: 'spotify', name: 'Spotify', color: '#1DB954', svg: '<svg viewBox="0 0 24 24" fill="#1DB954"><path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/></svg>' },
  { id: 'soundcloud', name: 'SoundCloud', color: '#FF5500', svg: '<svg viewBox="0 0 24 24" fill="#FF5500"><path d="M1.175 12.225c-.051 0-.094.046-.101.1l-.233 2.154.233 2.105c.007.058.05.098.101.098.05 0 .09-.04.099-.098l.255-2.105-.27-2.154c0-.057-.045-.1-.09-.1m-.899.828c-.06 0-.091.037-.104.094L0 14.479l.165 1.308c0 .055.045.094.09.094s.089-.045.104-.104l.21-1.319-.21-1.334c0-.061-.044-.09-.09-.09m1.83-1.229c-.061 0-.12.045-.12.104l-.21 2.563.225 2.458c0 .06.045.12.119.12.061 0 .105-.061.121-.12l.254-2.474-.254-2.548c-.016-.06-.061-.12-.121-.12m.945-.089c-.075 0-.135.06-.15.135l-.193 2.64.21 2.544c.016.077.075.138.149.138.075 0 .135-.061.15-.15l.24-2.532-.24-2.623c0-.075-.06-.135-.135-.135m1.124.135c-.09 0-.149.075-.165.166l-.217 2.42.2 2.563c.016.09.09.166.18.166s.15-.09.164-.18l.24-2.548-.24-2.408c-.016-.09-.075-.165-.165-.165m.96-.405c-.105 0-.18.09-.195.18l-.172 2.64.187 2.563c.015.09.09.18.195.18.09 0 .18-.09.18-.18l.209-2.563-.209-2.64c-.015-.09-.09-.18-.18-.18m.99-.555c-.104 0-.194.09-.21.195L4.8 13.995l.165 2.548c.016.12.105.21.225.21.104 0 .18-.09.21-.21l.193-2.548-.21-2.641c-.015-.105-.09-.195-.21-.195m1.065-.21c-.12 0-.21.09-.225.21l-.15 2.851.15 2.548c.015.12.105.21.225.21.12 0 .21-.09.224-.21l.166-2.548-.165-2.851c-.016-.12-.105-.21-.226-.21m1.05-.39c-.12 0-.225.105-.238.225l-.15 3.24.15 2.52c.016.12.12.226.24.226.12 0 .224-.105.225-.226l.165-2.52-.165-3.24c0-.12-.105-.225-.225-.225m1.095-.315c-.135 0-.255.12-.255.255l-.15 3.556.165 2.519c0 .135.12.255.254.255.135 0 .24-.12.255-.27l.15-2.504-.15-3.556c-.015-.135-.12-.255-.255-.255m1.11-.12c-.15 0-.27.12-.285.255l-.12 3.66.135 2.504c0 .15.12.27.27.27.135 0 .255-.12.27-.27l.135-2.504-.135-3.645c-.015-.15-.135-.27-.285-.27m1.086.135c-.164 0-.284.135-.284.285l-.106 3.525.12 2.49c0 .149.12.284.27.284.165 0 .285-.12.285-.285l.135-2.489-.135-3.525c-.015-.15-.135-.285-.285-.285m1.17-.285c-.18 0-.314.15-.314.315l-.105 3.81.105 2.49c.015.165.135.315.314.315.165 0 .315-.15.315-.315l.12-2.49-.12-3.81c0-.165-.15-.315-.315-.315m1.095.54c-.18 0-.315.15-.33.33l-.075 3.255.09 2.474c.015.18.149.33.33.33.165 0 .315-.15.315-.33l.105-2.474-.105-3.255c0-.18-.15-.33-.315-.33m1.155-.66c-.195 0-.345.165-.36.345l-.075 3.57.09 2.46c.015.195.165.36.36.36.18 0 .33-.165.345-.36l.09-2.46-.09-3.57c-.015-.18-.165-.345-.36-.345m1.14.18c-.195 0-.36.165-.375.36l-.06 3.39.075 2.445c.015.195.18.36.375.36.18 0 .345-.165.36-.36l.09-2.445-.09-3.39c-.015-.195-.18-.36-.375-.36m1.155-.15c-.21 0-.375.165-.39.375l-.06 3.54.075 2.43c.015.21.18.375.39.375.195 0 .36-.165.375-.375l.09-2.43-.09-3.54c-.015-.21-.18-.375-.39-.375m1.14.24c-.21 0-.39.18-.39.39l-.045 3.3.06 2.415c0 .21.18.39.39.39.195 0 .375-.18.375-.39l.075-2.415-.075-3.3c0-.21-.165-.39-.375-.39m4.395-.315c-.225 0-.39.18-.405.39l-.045 3.615.06 2.4c.015.21.18.39.39.39.21 0 .375-.18.39-.39l.075-2.4-.06-3.615c-.015-.21-.18-.39-.405-.39m-3.24.09c-.21 0-.39.18-.39.39l-.06 3.525.06 2.4c.016.21.181.39.39.39.21 0 .375-.18.391-.39l.06-2.4-.06-3.525c0-.21-.18-.39-.39-.39m1.095.195c-.21 0-.39.18-.405.39l-.045 3.33.06 2.4c.015.21.18.39.39.39.21 0 .39-.18.405-.39l.06-2.4-.06-3.33c-.015-.21-.18-.39-.405-.39m1.095-.15c-.21 0-.405.18-.405.405l-.045 3.48.045 2.385c.016.21.195.39.405.39.21 0 .39-.18.405-.39l.06-2.385-.06-3.48c0-.225-.195-.405-.405-.405m1.845 1.11c-.48 0-.912.21-1.215.54-.12-1.29-.99-2.28-2.115-2.55-.24-.06-.48-.09-.735-.09-1.665 0-3.015 1.365-3.015 3.03v6.12c0 .18.135.33.3.345h6.78c1.335 0 2.415-1.08 2.415-2.415s-1.08-2.49-2.415-2.49"/></svg>' },
  { id: 'linkedin', name: 'LinkedIn', color: '#0A66C2', svg: '<svg viewBox="0 0 24 24" fill="#0A66C2"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>' },
  { id: 'pinterest', name: 'Pinterest', color: '#BD081C', svg: '<svg viewBox="0 0 24 24" fill="#BD081C"><path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.39 18.592.026 11.985.026L12.017 0z"/></svg>' },
  { id: 'discord', name: 'Discord', color: '#5865F2', svg: '<svg viewBox="0 0 24 24" fill="#5865F2"><path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z"/></svg>' },
  { id: 'twitch', name: 'Twitch', color: '#9146FF', svg: '<svg viewBox="0 0 24 24" fill="#9146FF"><path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714Z"/></svg>' },
  { id: 'website', name: 'Web Sitesi', color: '#4285F4', svg: '<svg viewBox="0 0 24 24" fill="#4285F4"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/></svg>' },
  { id: 'email', name: 'E-posta', color: '#EA4335', svg: '<svg viewBox="0 0 24 24" fill="#EA4335"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>' },
  { id: 'other', name: 'Diğer', color: '#666666', svg: '<svg viewBox="0 0 24 24" fill="#666666"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg>' }
];

// Token'ı localStorage'dan al
const getToken = () => localStorage.getItem('adminToken');
const setToken = (token) => localStorage.setItem('adminToken', token);
const removeToken = () => localStorage.removeItem('adminToken');

// Axios instance with auth header
const api = axios.create({ baseURL: API_URL });
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers['x-admin-token'] = token;
  }
  return config;
});

// Süreyi formatla (saniye -> mm:ss)
const formatDuration = (seconds) => {
  if (!seconds) return '--:--';
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

// Boyutu formatla (byte -> MB)
const formatSize = (bytes) => {
  if (!bytes) return '--';
  const mb = bytes / (1024 * 1024);
  return `${mb.toFixed(2)} MB`;
};

// Toplam süreyi formatla (saniye -> saat:dakika:saniye)
const formatTotalDuration = (seconds) => {
  if (!seconds) return '0:00:00';
  const hours = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);
  return `${hours}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

const passwordInputStyle = {
  width: '100%',
  padding: '12px 16px',
  fontSize: '16px',
  borderRadius: '8px',
  border: '1px solid #333',
  background: '#0f0f1a',
  color: '#fff',
  boxSizing: 'border-box',
  marginBottom: '12px'
};

// Parola değiştirme formu (zorunlu değişim ekranında ve Güvenlik bölümünde kullanılır)
function ChangePasswordForm({ onSuccess, onUnauthorized }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const rules = [
    { ok: newPassword.length >= 10, text: 'En az 10 karakter' },
    { ok: /[a-zA-ZçğıöşüÇĞİÖŞÜ]/.test(newPassword) && /[0-9]/.test(newPassword), text: 'Harf ve rakam içermeli' },
    { ok: newPassword.length > 0 && newPassword === confirmPassword, text: 'Tekrarı ile aynı' }
  ];

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (rules.some(r => !r.ok)) {
      setError('Yeni parola kurallara uymuyor');
      return;
    }
    setSaving(true);
    try {
      const res = await api.post('/auth/change-password', { currentPassword, newPassword });
      setToken(res.data.token);
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      onSuccess();
    } catch (err) {
      if (err.response?.status === 401) onUnauthorized();
      else setError(err.response?.data?.error || 'Parola değiştirilemedi');
    }
    setSaving(false);
  };

  return (
    <form onSubmit={submit} style={{ maxWidth: '400px' }}>
      <input
        type="password"
        placeholder="Mevcut parola"
        autoComplete="current-password"
        value={currentPassword}
        onChange={(e) => setCurrentPassword(e.target.value)}
        style={passwordInputStyle}
      />
      <input
        type="password"
        placeholder="Yeni parola"
        autoComplete="new-password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        style={passwordInputStyle}
      />
      <input
        type="password"
        placeholder="Yeni parola (tekrar)"
        autoComplete="new-password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        style={passwordInputStyle}
      />
      <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 12px', fontSize: '0.9rem' }}>
        {rules.map(r => (
          <li key={r.text} style={{ color: r.ok ? '#4CAF50' : 'rgba(255,255,255,0.6)' }}>
            {r.ok ? '✓' : '•'} {r.text}
          </li>
        ))}
      </ul>
      {error && (
        <div style={{ color: '#ff6b6b', marginBottom: '12px', padding: '10px', background: 'rgba(255,107,107,0.1)', borderRadius: '6px' }}>
          {error}
        </div>
      )}
      <button type="submit" className="add-link-btn" disabled={saving || !currentPassword}>
        {saving ? 'Kaydediliyor...' : 'Parolayı Değiştir'}
      </button>
    </form>
  );
}

function Admin() {
  // Auth state
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  const [loginPassword, setLoginPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const [mustChangePassword, setMustChangePassword] = useState(false);
  const [securityOpen, setSecurityOpen] = useState(false);
  // Geçiş sesleri (parçalar arası kısa ses)
  const [jingles, setJingles] = useState([]);
  const [jinglesEnabled, setJinglesEnabled] = useState(false);
  const [jinglesOpen, setJinglesOpen] = useState(false);
  const [uploadingJingle, setUploadingJingle] = useState(false);
  // İndirme durumu: { key, percent }
  const [download, setDownload] = useState(null);

  const [tracks, setTracks] = useState([]);
  const [playlist, setPlaylist] = useState([]);
  const [youtubeUrls, setYoutubeUrls] = useState([]);
  const [radioState, setRadioState] = useState({});
  const [newYoutubeUrl, setNewYoutubeUrl] = useState('');
  const [newYoutubeName, setNewYoutubeName] = useState('');
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadFileName, setUploadFileName] = useState('');
  const [notification, setNotification] = useState(null);
  const [editingTrack, setEditingTrack] = useState(null);  // Düzenlenen track
  const [editReader, setEditReader] = useState('');
  const [editDescription, setEditDescription] = useState('');
  const [youtubeStreamKey, setYoutubeStreamKey] = useState('');
  const [youtubeStreamState, setYoutubeStreamState] = useState({ isStreaming: false });
  const [streamMedia, setStreamMedia] = useState({ items: [], activeMediaId: null });
  const [uploadingMedia, setUploadingMedia] = useState(false);
  const [mediaUploadProgress, setMediaUploadProgress] = useState(0);
  const [isMediaSectionOpen, setIsMediaSectionOpen] = useState(false);
  // Bağlantılar
  const [links, setLinks] = useState([]);
  const [newLinkName, setNewLinkName] = useState('');
  const [newLinkUrl, setNewLinkUrl] = useState('');
  const [newLinkIconId, setNewLinkIconId] = useState('');
  const [newLinkCustomIcon, setNewLinkCustomIcon] = useState(null);
  const [editingLink, setEditingLink] = useState(null);
  const [editLinkName, setEditLinkName] = useState('');
  const [editLinkUrl, setEditLinkUrl] = useState('');
  const [editLinkIconId, setEditLinkIconId] = useState('');
  const [editLinkCustomIcon, setEditLinkCustomIcon] = useState(null);
  // Slayt
  const [slides, setSlides] = useState([]);
  const [uploadingSlide, setUploadingSlide] = useState(false);
  const [slideUploadProgress, setSlideUploadProgress] = useState({ current: 0, total: 0 });
  const [remainingTime, setRemainingTime] = useState(null); // Kalan süre (saniye)
  // Okuyanlar
  const [readers, setReaders] = useState([]);
  const [newReaderName, setNewReaderName] = useState('');
  // Hakkında
  const [aboutText, setAboutText] = useState('');
  const [aboutSaving, setAboutSaving] = useState(false);
  // Duyuru
  const [announcements, setAnnouncements] = useState([]);
  const [announcementMeta, setAnnouncementMeta] = useState({ nextIndex: 0, tracksUntilNext: null });
  const [announcementInterval, setAnnouncementInterval] = useState(10);
  const [announcementIntervalInput, setAnnouncementIntervalInput] = useState('10');
  const [newAnnouncementName, setNewAnnouncementName] = useState('');
  const [uploadingAnnouncement, setUploadingAnnouncement] = useState(false);
  const [editingAnnouncementId, setEditingAnnouncementId] = useState(null);
  const [editingAnnouncementName, setEditingAnnouncementName] = useState('');
  // Toggle bölümleri (default kapalı)
  const [linksOpen, setLinksOpen] = useState(false);
  const [slidesOpen, setSlidesOpen] = useState(false);
  const [readersOpen, setReadersOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  const [announcementOpen, setAnnouncementOpen] = useState(false);
  const socketRef = useRef(null);

  // Admin panelinde tarayıcı/uygulama çubuk rengi lacivert olsun, çıkınca kırmızıya dönsün
  useEffect(() => {
    const meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) return;
    const previous = meta.getAttribute('content');
    meta.setAttribute('content', '#1a1a2e');
    return () => meta.setAttribute('content', previous);
  }, []);

  // Kalan süre hesaplama ve geri sayım
  useEffect(() => {
    if (!radioState.isPlaying || !radioState.trackStartTime || !radioState.currentTrack?.duration) {
      setRemainingTime(null);
      return;
    }

    const calculateRemaining = () => {
      const elapsed = Math.floor((Date.now() - radioState.trackStartTime) / 1000);
      const remaining = Math.max(0, radioState.currentTrack.duration - elapsed);
      setRemainingTime(remaining);
    };

    calculateRemaining();
    const interval = setInterval(calculateRemaining, 1000);
    return () => clearInterval(interval);
  }, [radioState.isPlaying, radioState.trackStartTime, radioState.currentTrack?.duration]);

  // Token doğrulama
  useEffect(() => {
    const verifyToken = async () => {
      const token = getToken();
      if (!token) {
        setIsCheckingAuth(false);
        return;
      }

      try {
        const res = await api.get('/auth/verify');
        if (res.data.valid) {
          setMustChangePassword(!!res.data.mustChangePassword);
          setIsAuthenticated(true);
        } else {
          removeToken();
        }
      } catch (err) {
        removeToken();
      }
      setIsCheckingAuth(false);
    };

    verifyToken();
  }, []);

  // Login fonksiyonu
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError('');

    try {
      const res = await axios.post(`${API_URL}/auth/login`, { password: loginPassword });
      if (res.data.success) {
        setToken(res.data.token);
        setMustChangePassword(!!res.data.mustChangePassword);
        setIsAuthenticated(true);
        setLoginPassword('');
      }
    } catch (err) {
      setLoginError(err.response?.data?.error || 'Giriş başarısız');
    }
  };

  // Logout fonksiyonu
  const handleLogout = async () => {
    try {
      await api.post('/auth/logout');
    } catch (err) {
      // ignore
    }
    removeToken();
    setIsAuthenticated(false);
    if (socketRef.current) {
      socketRef.current.disconnect();
      socketRef.current = null;
    }
  };

  // Notifikasyon göster
  const showNotification = (message, type = 'success') => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 4000);
  };

  const fetchTracks = useCallback(async () => {
    try {
      const res = await api.get('/tracks');
      setTracks(res.data);
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
    }
  }, []);

  const fetchPlaylist = useCallback(async () => {
    try {
      const res = await api.get('/playlist');
      setPlaylist(res.data);
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
    }
  }, []);

  const fetchYoutubeUrls = useCallback(async () => {
    try {
      const res = await api.get('/youtube');
      setYoutubeUrls(res.data);
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
    }
  }, []);

  const fetchRadioState = useCallback(async () => {
    try {
      const res = await api.get('/radio/state');
      setRadioState(res.data);
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
    }
  }, []);

  const fetchYoutubeStreamState = useCallback(async () => {
    try {
      const res = await api.get('/youtube-stream/state');
      setYoutubeStreamState(res.data);
      // Kaydedilmiş stream key varsa yükle
      if (res.data.streamKey) {
        setYoutubeStreamKey(res.data.streamKey);
      }
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
    }
  }, []);

  const fetchStreamMedia = useCallback(async () => {
    try {
      const res = await api.get('/stream-media');
      setStreamMedia(res.data);
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
    }
  }, []);

  const fetchLinks = useCallback(async () => {
    try {
      const res = await api.get('/links');
      setLinks(res.data);
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
    }
  }, []);

  const fetchSlides = useCallback(async () => {
    try {
      const res = await api.get('/slides');
      setSlides(res.data);
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
    }
  }, []);

  const fetchReaders = useCallback(async () => {
    try {
      const res = await api.get('/readers');
      setReaders(res.data);
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
    }
  }, []);

  const fetchAbout = useCallback(async () => {
    try {
      const res = await api.get('/about');
      setAboutText(res.data.text || '');
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
    }
  }, []);

  const applyAnnouncementData = (data) => {
    if (!data) return;
    if (Array.isArray(data.announcements)) setAnnouncements(data.announcements);
    if (data.interval) {
      setAnnouncementInterval(data.interval);
      setAnnouncementIntervalInput(String(data.interval));
    }
    setAnnouncementMeta({ nextIndex: data.nextIndex || 0, tracksUntilNext: data.tracksUntilNext ?? null });
  };

  const fetchAnnouncement = useCallback(async () => {
    try {
      const res = await api.get('/announcements');
      applyAnnouncementData(res.data);
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
    }
  }, []);

  // Duyuru bölümü açıkken parça değiştikçe "sıradaki duyuru" bilgisini tazele
  const currentTrackKey = `${radioState.currentTrack?.id || ''}|${radioState.currentTrack?.name || ''}`;
  useEffect(() => {
    if (isAuthenticated && announcementOpen) fetchAnnouncement();
  }, [currentTrackKey, announcementOpen, isAuthenticated, fetchAnnouncement]);

  useEffect(() => {
    // Sadece authenticated ise verileri yükle
    if (!isAuthenticated || mustChangePassword) return;

    // Socket bağlantısını component mount olduğunda oluştur
    socketRef.current = io(BASE_URL);

    fetchTracks();
    fetchPlaylist();
    fetchYoutubeUrls();
    fetchRadioState();
    fetchYoutubeStreamState();
    fetchStreamMedia();
    fetchLinks();
    fetchSlides();
    fetchReaders();
    fetchAbout();
    fetchAnnouncement();

    socketRef.current.on('radio-state', (state) => {
      setRadioState(state);
    });

    socketRef.current.on('playlist-updated', () => {
      fetchPlaylist();
    });

    socketRef.current.on('youtube-stream-state', (state) => {
      setYoutubeStreamState(state);
    });

    socketRef.current.on('stream-media-changed', (data) => {
      setStreamMedia(data);
    });

    // Cleanup: component unmount olduğunda socket bağlantısını kapat
    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, [isAuthenticated, mustChangePassword, fetchTracks, fetchPlaylist, fetchYoutubeUrls, fetchRadioState, fetchYoutubeStreamState, fetchStreamMedia, fetchLinks, fetchSlides, fetchReaders, fetchAbout, fetchAnnouncement]);

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('audio', file);

    setUploading(true);
    setUploadProgress(0);
    setUploadFileName(file.name);

    try {
      await api.post('/tracks/upload', formData, {
        onUploadProgress: (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(percent);
        }
      });
      showNotification(`"${file.name}" başarıyla yüklendi!`, 'success');
      fetchTracks();
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
      else showNotification('Yükleme hatası: ' + err.message, 'error');
    }
    setUploading(false);
    setUploadProgress(0);
    setUploadFileName('');
    e.target.value = '';
  };

  // Stream Media Handlers
  const handleMediaUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('media', file);

    setUploadingMedia(true);
    setMediaUploadProgress(0);

    try {
      await api.post('/stream-media/upload', formData, {
        onUploadProgress: (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setMediaUploadProgress(percent);
        }
      });
      showNotification(`"${file.name}" yüklendi!`, 'success');
      fetchStreamMedia();
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
      else showNotification('Yükleme hatası: ' + (err.response?.data?.error || err.message), 'error');
    }
    setUploadingMedia(false);
    setMediaUploadProgress(0);
    e.target.value = '';
  };

  const activateMedia = async (mediaId) => {
    try {
      await api.post(`/stream-media/${mediaId}/activate`);
      showNotification('Medya aktif edildi', 'success');
      fetchStreamMedia();
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
      else showNotification('Medya aktif edilemedi', 'error');
    }
  };

  const deleteMedia = async (mediaId) => {
    if (window.confirm('Bu medyayı silmek istediğinize emin misiniz?')) {
      try {
        await api.delete(`/stream-media/${mediaId}`);
        showNotification('Medya silindi', 'success');
        fetchStreamMedia();
      } catch (err) {
        if (err.response?.status === 401) handleLogout();
        else showNotification(err.response?.data?.error || 'Silme hatası', 'error');
      }
    }
  };

  const updateBitrate = async (newBitrate) => {
    try {
      await api.post('/stream-media/settings', { videoBitrate: newBitrate });
      showNotification(`Video bitrate ${newBitrate}k olarak ayarlandı`, 'success');
      fetchStreamMedia();
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
      else showNotification(err.response?.data?.error || 'Bitrate güncellenemedi', 'error');
    }
  };

  const updateResolution = async (newResolution) => {
    try {
      await api.post('/stream-media/settings', { resolution: newResolution });
      showNotification(`Çözünürlük ${newResolution} olarak ayarlandı`, 'success');
      fetchStreamMedia();
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
      else showNotification(err.response?.data?.error || 'Çözünürlük güncellenemedi', 'error');
    }
  };

  const addToPlaylist = async (trackId) => {
    await api.post(`/playlist/add/${trackId}`);
    fetchPlaylist();
    showNotification('Parça listeye eklendi', 'success');
  };

  const removeFromPlaylist = async (trackId) => {
    await api.delete(`/playlist/${trackId}`);
    fetchPlaylist();
  };

  const deleteTrack = async (trackId) => {
    if (window.confirm('Bu dosyayı silmek istediğinize emin misiniz?')) {
      await api.delete(`/tracks/${trackId}`);
      fetchTracks();
      fetchPlaylist();
      showNotification('Dosya silindi', 'success');
    }
  };

  // Track düzenleme fonksiyonları
  const startEditTrack = (track) => {
    setEditingTrack(track);
    setEditReader(track.reader || '');
    setEditDescription(track.description || '');
  };

  const cancelEditTrack = () => {
    setEditingTrack(null);
    setEditReader('');
    setEditDescription('');
  };

  const saveTrackEdit = async () => {
    if (!editingTrack) return;
    try {
      await api.put(`/tracks/${editingTrack.id}`, {
        reader: editReader,
        description: editDescription
      });
      showNotification('Bilgiler güncellendi', 'success');
      fetchTracks();
      fetchPlaylist();
      cancelEditTrack();
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
      else showNotification('Güncelleme hatası', 'error');
    }
  };

  const moveInPlaylist = async (index, direction) => {
    const newPlaylist = [...playlist];
    const newIndex = index + direction;
    if (newIndex < 0 || newIndex >= newPlaylist.length) return;

    [newPlaylist[index], newPlaylist[newIndex]] = [newPlaylist[newIndex], newPlaylist[index]];
    const trackIds = newPlaylist.map(t => t.id);
    await api.post('/playlist', { trackIds });
    fetchPlaylist();
  };

  const shufflePlaylist = async () => {
    try {
      const res = await api.post('/playlist/shuffle');
      showNotification(res.data.message || 'Playlist karıştırıldı', 'success');
      fetchPlaylist();
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
      else showNotification('Karıştırma hatası', 'error');
    }
  };

  // Bağlantı fonksiyonları
  const addLink = async () => {
    if (!newLinkName || !newLinkUrl) {
      showNotification('İsim ve URL gerekli', 'error');
      return;
    }

    if (!newLinkIconId && !newLinkCustomIcon) {
      showNotification('Hazır icon seçin veya özel icon yükleyin', 'error');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('name', newLinkName);
      formData.append('url', newLinkUrl);

      if (newLinkCustomIcon) {
        formData.append('customIcon', newLinkCustomIcon);
      } else if (newLinkIconId) {
        formData.append('iconId', newLinkIconId);
      }

      await api.post('/links', formData);
      showNotification('Bağlantı eklendi', 'success');
      setNewLinkName('');
      setNewLinkUrl('');
      setNewLinkIconId('');
      setNewLinkCustomIcon(null);
      fetchLinks();
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
      else showNotification('Ekleme hatası', 'error');
    }
  };

  const startEditLink = (link) => {
    setEditingLink(link);
    setEditLinkName(link.name);
    setEditLinkUrl(link.url);
    setEditLinkIconId(link.iconId || '');
    setEditLinkCustomIcon(null);
  };

  const cancelEditLink = () => {
    setEditingLink(null);
    setEditLinkName('');
    setEditLinkUrl('');
    setEditLinkIconId('');
    setEditLinkCustomIcon(null);
  };

  const saveEditLink = async () => {
    if (!editingLink) return;

    try {
      const formData = new FormData();
      formData.append('name', editLinkName);
      formData.append('url', editLinkUrl);

      if (editLinkCustomIcon) {
        formData.append('customIcon', editLinkCustomIcon);
      } else if (editLinkIconId) {
        formData.append('iconId', editLinkIconId);
      }

      await api.put(`/links/${editingLink.id}`, formData);
      showNotification('Bağlantı güncellendi', 'success');
      cancelEditLink();
      fetchLinks();
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
      else showNotification('Güncelleme hatası', 'error');
    }
  };

  // Icon ID'den icon bilgisini al
  const getIconById = (iconId) => {
    return PREDEFINED_ICONS.find(icon => icon.id === iconId) || PREDEFINED_ICONS.find(icon => icon.id === 'other');
  };

  const deleteLink = async (id) => {
    if (window.confirm('Bu bağlantıyı silmek istediğinize emin misiniz?')) {
      try {
        await api.delete(`/links/${id}`);
        showNotification('Bağlantı silindi', 'success');
        fetchLinks();
      } catch (err) {
        if (err.response?.status === 401) handleLogout();
        else showNotification('Silme hatası', 'error');
      }
    }
  };

  const moveLinkInList = async (index, direction) => {
    const newLinks = [...links];
    const newIndex = index + direction;
    if (newIndex < 0 || newIndex >= newLinks.length) return;

    [newLinks[index], newLinks[newIndex]] = [newLinks[newIndex], newLinks[index]];
    const linkIds = newLinks.map(l => l.id);

    try {
      await api.post('/links/reorder', { linkIds });
      setLinks(newLinks);
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
      else showNotification('Sıralama hatası', 'error');
    }
  };

  // Slayt fonksiyonları
  const handleSlideUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    setUploadingSlide(true);
    setSlideUploadProgress({ current: 0, total: files.length });

    let successCount = 0;
    let failCount = 0;

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const formData = new FormData();
      formData.append('image', file);

      setSlideUploadProgress({ current: i + 1, total: files.length });

      try {
        await api.post('/slides', formData);
        successCount++;
      } catch (err) {
        if (err.response?.status === 401) {
          handleLogout();
          return;
        }
        failCount++;
      }
    }

    fetchSlides();

    if (failCount === 0) {
      showNotification(`${successCount} resim başarıyla yüklendi`, 'success');
    } else {
      showNotification(`${successCount} başarılı, ${failCount} başarısız`, failCount > 0 ? 'error' : 'success');
    }

    setUploadingSlide(false);
    setSlideUploadProgress({ current: 0, total: 0 });
    e.target.value = '';
  };

  const deleteSlide = async (id) => {
    if (window.confirm('Bu resmi silmek istediğinize emin misiniz?')) {
      try {
        await api.delete(`/slides/${id}`);
        showNotification('Resim silindi', 'success');
        fetchSlides();
      } catch (err) {
        if (err.response?.status === 401) handleLogout();
        else showNotification('Silme hatası', 'error');
      }
    }
  };

  // Okuyanlar fonksiyonları
  const addReader = async () => {
    if (!newReaderName.trim()) {
      showNotification('İsim gerekli', 'error');
      return;
    }
    try {
      await api.post('/readers', { name: newReaderName.trim() });
      showNotification('Okuyan eklendi', 'success');
      setNewReaderName('');
      fetchReaders();
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
      else showNotification('Ekleme hatası', 'error');
    }
  };

  const deleteReader = async (id) => {
    if (window.confirm('Bu okuyanı silmek istediğinize emin misiniz?')) {
      try {
        await api.delete(`/readers/${id}`);
        showNotification('Okuyan silindi', 'success');
        fetchReaders();
      } catch (err) {
        if (err.response?.status === 401) handleLogout();
        else showNotification('Silme hatası', 'error');
      }
    }
  };

  const moveReaderInList = async (index, direction) => {
    const newReaders = [...readers];
    const newIndex = index + direction;
    if (newIndex < 0 || newIndex >= newReaders.length) return;

    [newReaders[index], newReaders[newIndex]] = [newReaders[newIndex], newReaders[index]];
    const readerIds = newReaders.map(r => r.id);

    try {
      await api.post('/readers/reorder', { readerIds });
      setReaders(newReaders);
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
      else showNotification('Sıralama hatası', 'error');
    }
  };

  // Hakkında kaydet
  const saveAbout = async () => {
    setAboutSaving(true);
    try {
      await api.put('/about', { text: aboutText });
      showNotification('Hakkında metni kaydedildi', 'success');
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
      else showNotification('Kaydetme hatası', 'error');
    }
    setAboutSaving(false);
  };

  // Duyuru fonksiyonları
  const handleAnnouncementError = (err, fallback) => {
    if (err.response?.status === 401) handleLogout();
    else showNotification(err.response?.data?.error || fallback, 'error');
  };

  const uploadAnnouncements = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = '';
    if (files.length === 0) return;

    setUploadingAnnouncement(true);
    let uploaded = 0;
    for (const file of files) {
      const formData = new FormData();
      formData.append('announcement', file);
      // Tek dosyada girilen ad kullanılır, çoklu yüklemede dosya adları
      if (files.length === 1 && newAnnouncementName.trim()) {
        formData.append('name', newAnnouncementName.trim());
      }
      try {
        const res = await api.post('/announcements', formData);
        applyAnnouncementData(res.data);
        uploaded++;
      } catch (err) {
        handleAnnouncementError(err, `${file.name} yüklenemedi`);
        if (err.response?.status === 401) break;
      }
    }
    if (uploaded > 0) {
      showNotification(uploaded === 1 ? 'Duyuru eklendi' : `${uploaded} duyuru eklendi`, 'success');
      setNewAnnouncementName('');
    }
    setUploadingAnnouncement(false);
  };

  const replaceAnnouncementFile = async (id, e) => {
    const file = e.target.files[0];
    e.target.value = '';
    if (!file) return;
    const formData = new FormData();
    formData.append('announcement', file);
    setUploadingAnnouncement(true);
    try {
      const res = await api.post(`/announcements/${id}/file`, formData);
      applyAnnouncementData(res.data);
      showNotification('Duyuru dosyası değiştirildi', 'success');
    } catch (err) {
      handleAnnouncementError(err, 'Dosya değiştirme hatası');
    }
    setUploadingAnnouncement(false);
  };

  const updateAnnouncement = async (id, changes, successMsg) => {
    try {
      const res = await api.put(`/announcements/${id}`, changes);
      applyAnnouncementData(res.data);
      if (successMsg) showNotification(successMsg, 'success');
      return true;
    } catch (err) {
      handleAnnouncementError(err, 'Güncelleme hatası');
      return false;
    }
  };

  const saveAnnouncementName = async () => {
    const name = editingAnnouncementName.trim();
    if (!name) return;
    if (await updateAnnouncement(editingAnnouncementId, { name }, 'Duyuru adı güncellendi')) {
      setEditingAnnouncementId(null);
    }
  };

  const deleteAnnouncement = async (item) => {
    if (!window.confirm(`"${item.name}" duyurusunu silmek istediğinize emin misiniz?`)) return;
    try {
      const res = await api.delete(`/announcements/${item.id}`);
      applyAnnouncementData(res.data);
      showNotification('Duyuru silindi', 'success');
    } catch (err) {
      handleAnnouncementError(err, 'Silme hatası');
    }
  };

  const moveAnnouncement = async (index, direction) => {
    const newIndex = index + direction;
    if (newIndex < 0 || newIndex >= announcements.length) return;
    const reordered = [...announcements];
    [reordered[index], reordered[newIndex]] = [reordered[newIndex], reordered[index]];
    try {
      const res = await api.post('/announcements/reorder', { announcementIds: reordered.map(a => a.id) });
      applyAnnouncementData(res.data);
    } catch (err) {
      handleAnnouncementError(err, 'Sıralama hatası');
    }
  };

  // ============ SES DOSYASI İNDİRME ============
  // Token header'da gönderildiği için dosya blob olarak alınıp tarayıcıya kaydettirilir
  const downloadAudio = async (kind, item) => {
    const key = `${kind}:${item.id}`;
    if (download) {
      showNotification('Önceki indirme devam ediyor', 'error');
      return;
    }
    setDownload({ key, percent: 0 });
    try {
      const res = await api.get(`/${kind}/${item.id}/download`, {
        responseType: 'blob',
        onDownloadProgress: (e) => {
          const total = e.total || item.size;
          if (total) setDownload({ key, percent: Math.min(100, Math.round((e.loaded / total) * 100)) });
        }
      });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${(item.name || 'ses').replace(/[\\/:*?"<>|]+/g, ' ').trim()}.mp3`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 10000);
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
      else showNotification('İndirme hatası', 'error');
    }
    setDownload(null);
  };

  const renderDownloadButton = (kind, item) => {
    const key = `${kind}:${item.id}`;
    const active = download?.key === key;
    return (
      <button
        onClick={() => downloadAudio(kind, item)}
        disabled={!!download}
        title="İndir"
      >
        {active ? `${download.percent}%` : '⬇'}
      </button>
    );
  };

  // ============ GEÇİŞ SESLERİ ============
  const applyJingleData = (data) => {
    if (!data) return;
    if (Array.isArray(data.jingles)) setJingles(data.jingles);
    if (typeof data.enabled === 'boolean') setJinglesEnabled(data.enabled);
  };

  const fetchJingles = async () => {
    try {
      const res = await api.get('/jingles');
      applyJingleData(res.data);
    } catch (err) {
      if (err.response?.status === 401) handleLogout();
    }
  };

  const toggleJinglesEnabled = async () => {
    try {
      const res = await api.put('/jingles/settings', { enabled: !jinglesEnabled });
      applyJingleData(res.data);
      showNotification(res.data.enabled ? 'Geçiş sesleri açıldı' : 'Geçiş sesleri kapatıldı', 'success');
    } catch (err) {
      handleAnnouncementError(err, 'Ayar kaydedilemedi');
    }
  };

  const uploadJingles = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = '';
    if (files.length === 0) return;
    setUploadingJingle(true);
    let uploaded = 0;
    for (const file of files) {
      const formData = new FormData();
      formData.append('jingle', file);
      try {
        const res = await api.post('/jingles', formData);
        applyJingleData(res.data);
        uploaded++;
      } catch (err) {
        handleAnnouncementError(err, `${file.name} yüklenemedi`);
        if (err.response?.status === 401) break;
      }
    }
    if (uploaded > 0) showNotification(`${uploaded} geçiş sesi eklendi`, 'success');
    setUploadingJingle(false);
  };

  const updateJingle = async (id, changes) => {
    try {
      const res = await api.put(`/jingles/${id}`, changes);
      applyJingleData(res.data);
    } catch (err) {
      handleAnnouncementError(err, 'Güncelleme hatası');
    }
  };

  const renameJingle = (item) => {
    const name = window.prompt('Geçiş sesinin yeni adı:', item.name);
    if (name && name.trim() && name.trim() !== item.name) updateJingle(item.id, { name: name.trim() });
  };

  const deleteJingle = async (item) => {
    if (!window.confirm(`"${item.name}" geçiş sesini silmek istediğinize emin misiniz?`)) return;
    try {
      const res = await api.delete(`/jingles/${item.id}`);
      applyJingleData(res.data);
      showNotification('Geçiş sesi silindi', 'success');
    } catch (err) {
      handleAnnouncementError(err, 'Silme hatası');
    }
  };

  useEffect(() => {
    if (isAuthenticated && !mustChangePassword) fetchJingles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, mustChangePassword]);

  const saveAnnouncementInterval = async () => {
    const interval = parseInt(announcementIntervalInput, 10);
    if (!Number.isInteger(interval) || interval < 1) {
      showNotification('Geçerli bir sayı girin (en az 1)', 'error');
      return;
    }
    try {
      const res = await api.put('/announcements/settings', { interval });
      applyAnnouncementData(res.data);
      showNotification(`Duyurular artık her ${interval} parçada bir çalınacak`, 'success');
    } catch (err) {
      handleAnnouncementError(err, 'Ayar kaydedilemedi');
    }
  };

  const addYoutubeUrl = async () => {
    if (!newYoutubeUrl) return;
    await api.post('/youtube', {
      url: newYoutubeUrl,
      name: newYoutubeName || newYoutubeUrl
    });
    setNewYoutubeUrl('');
    setNewYoutubeName('');
    fetchYoutubeUrls();
  };

  const deleteYoutubeUrl = async (id) => {
    await api.delete(`/youtube/${id}`);
    fetchYoutubeUrls();
  };

  // Radio controls
  const startRadio = async () => {
    await api.post('/radio/start');
    showNotification('Yayın başlatıldı', 'success');
  };

  const resetListeners = async () => {
    await api.post('/radio/reset-listeners');
    showNotification('Dinleyiciler resetlendi', 'success');
  };

  const nextTrack = async () => {
    try {
      await api.post('/radio/next');
      showNotification('Sonraki parçaya geçiliyor', 'success');
    } catch (err) {
      console.error('Sonraki parça hatası:', err);
      showNotification('Sonraki parçaya geçilemedi: ' + (err.response?.data?.error || err.message), 'error');
    }
  };

  const prevTrack = async () => {
    try {
      await api.post('/radio/prev');
      showNotification('Önceki parçaya geçiliyor', 'success');
    } catch (err) {
      console.error('Önceki parça hatası:', err);
      showNotification('Önceki parçaya geçilemedi: ' + (err.response?.data?.error || err.message), 'error');
    }
  };

  const playTrack = async (trackId) => {
    await api.post(`/radio/play/${trackId}`);
  };

  // YouTube Stream controls
  const startYoutubeStream = async () => {
    if (!youtubeStreamKey) {
      showNotification('Lütfen YouTube Stream Key girin', 'error');
      return;
    }
    try {
      const res = await api.post('/youtube-stream/start', { streamKey: youtubeStreamKey });
      if (!res.data.success) {
        showNotification(res.data.message, 'error');
      } else {
        showNotification('YouTube yayını başlatıldı', 'success');
      }
    } catch (err) {
      showNotification('YouTube stream başlatılamadı: ' + err.message, 'error');
    }
  };

  const stopYoutubeStream = async () => {
    try {
      await api.post('/youtube-stream/stop');
      showNotification('YouTube yayını durduruldu', 'success');
    } catch (err) {
      showNotification('YouTube stream durdurulamadı: ' + err.message, 'error');
    }
  };

  const saveStreamKey = async (key) => {
    try {
      await api.post('/youtube-stream/save-key', { streamKey: key });
    } catch (err) {
      console.error('Stream key kaydedilemedi:', err);
    }
  };

  const handlePublishStream = async () => {
    // Aktif media kontrolü
    if (!streamMedia.activeMediaId) {
      showNotification('Lütfen önce bir görsel veya video seçin', 'error');
      return;
    }

    // Stream key kontrolü
    if (!youtubeStreamKey) {
      showNotification('Lütfen YouTube Stream Key girin', 'error');
      return;
    }

    // Eğer stream zaten çalışıyorsa, önce durdur sonra yeniden başlat
    if (youtubeStreamState.isStreaming) {
      try {
        await api.post('/youtube-stream/stop');
        // Biraz bekle ki FFmpeg tamamen kapansın
        await new Promise(resolve => setTimeout(resolve, 2000));
        await startYoutubeStream();
        showNotification('Stream yeni ayarlarla yeniden başlatıldı', 'success');
      } catch (err) {
        showNotification('Stream yeniden başlatılamadı: ' + err.message, 'error');
      }
    } else {
      // Stream çalışmıyorsa direkt başlat
      await startYoutubeStream();
    }
  };

  // Playlist toplam süresini hesapla
  const totalPlaylistDuration = playlist.reduce((total, track) => total + (track.duration || 0), 0);

  // Tüm dosyaların toplam boyutunu hesapla
  const totalTracksSize = tracks.reduce((total, track) => total + (track.size || 0), 0);

  // Auth kontrolü yapılırken yükleniyor göster
  if (isCheckingAuth) {
    return (
      <div className="admin-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <div style={{ textAlign: 'center' }}>
          <div className="loading-spinner"></div>
          <p>Yükleniyor...</p>
        </div>
      </div>
    );
  }

  // Login ekranı
  if (!isAuthenticated) {
    return (
      <div className="admin-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <div className="login-box" style={{
          background: '#1a1a2e',
          padding: '40px',
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
          maxWidth: '400px',
          width: '100%'
        }}>
          <h1 style={{ textAlign: 'center', marginBottom: '30px', color: '#fff' }}>Radyo Yönetim Paneli</h1>
          <form onSubmit={handleLogin}>
            <div style={{ marginBottom: '20px' }}>
              <input
                type="password"
                placeholder="Parola"
                autoComplete="current-password"
                value={loginPassword}
                onChange={(e) => setLoginPassword(e.target.value)}
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  fontSize: '16px',
                  borderRadius: '8px',
                  border: '1px solid #333',
                  background: '#0f0f1a',
                  color: '#fff',
                  boxSizing: 'border-box'
                }}
                autoFocus
              />
            </div>
            {loginError && (
              <div style={{
                color: '#ff6b6b',
                marginBottom: '15px',
                padding: '10px',
                background: 'rgba(255,107,107,0.1)',
                borderRadius: '6px',
                textAlign: 'center'
              }}>
                {loginError}
              </div>
            )}
            <button
              type="submit"
              style={{
                width: '100%',
                padding: '12px',
                fontSize: '16px',
                fontWeight: 'bold',
                borderRadius: '8px',
                border: 'none',
                background: '#4CAF50',
                color: '#fff',
                cursor: 'pointer'
              }}
            >
              Giriş Yap
            </button>
          </form>
        </div>
      </div>
    );
  }

  // Varsayılan / zayıf parola: panel açılmadan önce değiştirilmesi zorunlu
  if (mustChangePassword) {
    return (
      <div className="admin-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <div className="login-box" style={{
          background: '#1a1a2e',
          padding: '40px',
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
          maxWidth: '440px',
          width: '100%'
        }}>
          <h1 style={{ textAlign: 'center', marginBottom: '12px', color: '#fff', fontSize: '1.5rem' }}>Parolanızı Değiştirin</h1>
          <p style={{ color: 'rgba(255,255,255,0.7)', marginBottom: '24px', textAlign: 'center' }}>
            Güvenliğiniz için varsayılan veya zayıf parola ile devam edilemez. Lütfen güçlü yeni bir parola belirleyin.
          </p>
          <ChangePasswordForm
            onSuccess={() => setMustChangePassword(false)}
            onUnauthorized={handleLogout}
          />
          <button
            onClick={handleLogout}
            style={{ marginTop: '16px', background: 'none', border: 'none', color: 'rgba(255,255,255,0.6)', cursor: 'pointer' }}
          >
            Çıkış Yap
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-container">
      {/* Notification */}
      {notification && (
        <div className={`notification ${notification.type}`}>
          {notification.type === 'success' ? '✓' : '✕'} {notification.message}
        </div>
      )}

      {/* Track Edit Modal */}
      {editingTrack && (
        <div className="modal-overlay" onClick={cancelEditTrack}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Ses Dosyası Bilgileri</h3>
            <p className="modal-track-name">{editingTrack.name}</p>
            <div className="modal-field">
              <label>Okuyucu Adı:</label>
              <input
                type="text"
                placeholder="Okuyanın adı"
                value={editReader}
                onChange={(e) => setEditReader(e.target.value)}
              />
            </div>
            <div className="modal-field">
              <label>Açıklama:</label>
              <textarea
                placeholder="Açıklama (örn: Sözler, Mektubat, vs.)"
                value={editDescription}
                onChange={(e) => setEditDescription(e.target.value)}
                rows={3}
              />
            </div>
            <div className="modal-actions">
              <button onClick={cancelEditTrack} className="cancel-btn">İptal</button>
              <button onClick={saveTrackEdit} className="save-btn">Kaydet</button>
            </div>
          </div>
        </div>
      )}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h1 style={{ margin: 0 }}>Radyo Yönetim Paneli</h1>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button
            onClick={() => window.open('/', '_blank')}
            style={{
              padding: '8px 16px',
              background: '#0f3460',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer'
            }}
          >
            🎧 Dinle
          </button>
          <button
            onClick={handleLogout}
            style={{
              padding: '8px 16px',
              background: '#666',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer'
            }}
          >
            Çıkış Yap
          </button>
        </div>
      </div>

      {/* Radio Control */}
      <section className="section">
        <h2>Yayın Kontrolü</h2>
        <div className="stream-control">
          <div className="current-track">
            <strong>Durum:</strong>{' '}
            {radioState.isPlaying ? (
              <span className="status-live">CANLI YAYIN</span>
            ) : (
              <span className="status-offline">KAPALI</span>
            )}
          </div>
          <div className="current-track">
            <strong>Şu an çalıyor:</strong>{' '}
            {radioState.currentTrack ? radioState.currentTrack.name : 'Yok'}
          </div>
          {radioState.isPlaying && remainingTime !== null && (
            <div className="current-track remaining-time">
              <strong>Kalan süre:</strong>{' '}
              <span className="countdown">{formatDuration(remainingTime)}</span>
            </div>
          )}
          <div className="current-track">
            <strong>Dinleyici sayısı:</strong> {radioState.listeners || 0}
          </div>
          <div className="control-buttons">
            <button onClick={prevTrack} disabled={!radioState.isPlaying}>⏮ Önceki</button>
            {!radioState.isPlaying && (
              <button onClick={startRadio} className="start-btn">▶ Yayını Başlat</button>
            )}
            {radioState.isPlaying && (
              <button onClick={resetListeners} className="reset-btn">🔄 Dinleyicileri Resetle</button>
            )}
            <button onClick={nextTrack} disabled={!radioState.isPlaying}>Sonraki ⏭</button>
          </div>
        </div>
      </section>

      {/* YouTube Live Stream */}
      <section className="section youtube-stream-section">
        <h2>YouTube Canlı Yayın</h2>
        <div className="stream-control">
          <div className="current-track">
            <strong>YouTube Durumu:</strong>{' '}
            {youtubeStreamState.isStreaming ? (
              <span className="status-live">YOUTUBE'DA CANLI</span>
            ) : (
              <span className="status-offline">KAPALI</span>
            )}
          </div>
          <div className="youtube-stream-setup">
            <input
              type="text"
              placeholder="YouTube Stream Key"
              value={youtubeStreamKey}
              onChange={(e) => setYoutubeStreamKey(e.target.value)}
              onBlur={(e) => saveStreamKey(e.target.value)}
              disabled={youtubeStreamState.isStreaming}
              style={{ marginRight: '10px', padding: '8px', width: '300px', fontFamily: 'monospace' }}
            />
            {youtubeStreamState.isStreaming ? (
              <button onClick={stopYoutubeStream} className="stop-btn">
                YouTube Yayınını Durdur
              </button>
            ) : (
              <button onClick={startYoutubeStream} className="start-btn">
                YouTube'a Yayınla
              </button>
            )}
          </div>
          <p className="hint" style={{ marginTop: '10px' }}>
            Stream Key'i YouTube Studio &gt; Canlı Yayın &gt; Stream ayarlarından alabilirsiniz.
            Radyo yayınını başlattıktan sonra YouTube'a aktarabilirsiniz.
          </p>
        </div>
      </section>

      {/* Stream Media Management */}
      <section className="section stream-media-section">
        <h2
          onClick={() => setIsMediaSectionOpen(!isMediaSectionOpen)}
          style={{ cursor: 'pointer', userSelect: 'none', display: 'flex', alignItems: 'center', gap: '0.5rem' }}
        >
          <span>{isMediaSectionOpen ? '▼' : '▶'}</span>
          YouTube Yayın Görseli / Videosu
        </h2>

        {isMediaSectionOpen && (
          <>
            {/* Upload Area */}
            <div className="upload-area" style={{ marginBottom: '1.5rem' }}>
          <input
            type="file"
            accept=".jpg,.jpeg,.png,.mp4,image/jpeg,image/png,video/mp4"
            onChange={handleMediaUpload}
            disabled={uploadingMedia}
            id="media-upload"
            style={{ display: 'none' }}
          />
          <label htmlFor="media-upload" className={`upload-button ${uploadingMedia ? 'disabled' : ''}`}>
            {uploadingMedia ? 'Yükleniyor...' : 'Görsel/Video Yükle'}
          </label>
          <span className="hint" style={{ marginLeft: '1rem' }}>
            JPG, PNG (görsel) veya MP4 (video) - Maks 100MB
          </span>

          {uploadingMedia && (
            <div className="upload-progress-container" style={{ marginTop: '1rem' }}>
              <div className="progress-bar">
                <div className="progress-fill" style={{ width: `${mediaUploadProgress}%` }} />
              </div>
              <div className="progress-text">{mediaUploadProgress}%</div>
            </div>
          )}
        </div>

        {/* Media List */}
        <div className="media-list">
          {streamMedia.items?.map(media => (
            <div
              key={media.id}
              className={`media-item ${streamMedia.activeMediaId === media.id ? 'active' : ''}`}
            >
              <div className="media-preview">
                {media.type === 'image' ? (
                  <img
                    src={media.isDefault ? `${BASE_URL}/assets/images/${media.filename}` : `${BASE_URL}/stream-media/${media.filename}`}
                    alt={media.originalName}
                  />
                ) : (
                  <div className="video-icon">VIDEO</div>
                )}
              </div>
              <div className="media-info">
                <span className="media-name">{media.originalName}</span>
                <div className="media-meta">
                  <span className="meta-item">
                    {media.type === 'image' ? 'Görsel' : `Video (${media.duration || '?'}s)`}
                  </span>
                  <span className="meta-item">{formatSize(media.size)}</span>
                </div>
              </div>
              <div className="media-actions">
                {streamMedia.activeMediaId === media.id ? (
                  <span className="active-badge">AKTİF</span>
                ) : (
                  <button onClick={() => activateMedia(media.id)} className="activate-btn">
                    Seç
                  </button>
                )}
                {!media.isDefault && (
                  <button onClick={() => deleteMedia(media.id)} className="danger">
                    Sil
                  </button>
                )}
              </div>
            </div>
          ))}
          {(!streamMedia.items || streamMedia.items.length === 0) && (
            <p className="hint">Henüz medya yüklenmemiş.</p>
          )}
        </div>

        {/* Video Settings */}
        <div className="video-settings" style={{ marginTop: '1.5rem', padding: '1rem', background: 'rgba(255,255,255,0.05)', borderRadius: '10px' }}>
          <h4 style={{ margin: '0 0 1rem 0', fontSize: '1rem' }}>Video Ayarları</h4>

          {/* Resolution Setting */}
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
              <span>Çözünürlük:</span>
              <select
                value={streamMedia.resolution || '720p'}
                onChange={(e) => {
                  setStreamMedia({...streamMedia, resolution: e.target.value});
                  updateResolution(e.target.value);
                }}
                style={{
                  padding: '8px 12px',
                  borderRadius: '5px',
                  border: '1px solid rgba(255,255,255,0.2)',
                  background: 'rgba(0,0,0,0.3)',
                  color: 'inherit',
                  fontSize: '1rem',
                  cursor: 'pointer'
                }}
              >
                <option value="360p">360p (640x360) - Düşük</option>
                <option value="480p">480p (854x480) - Orta</option>
                <option value="720p">720p (1280x720) - HD</option>
                <option value="1080p">1080p (1920x1080) - Full HD</option>
              </select>
            </label>
          </div>

          {/* Bitrate Setting */}
          <label style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
            <span>Video Bitrate:</span>
            <input
              type="range"
              min="500"
              max="6000"
              step="100"
              value={streamMedia.videoBitrate || 1500}
              onChange={(e) => setStreamMedia({...streamMedia, videoBitrate: parseInt(e.target.value)})}
              onMouseUp={(e) => updateBitrate(parseInt(e.target.value))}
              onTouchEnd={(e) => updateBitrate(parseInt(e.target.value))}
              style={{ flex: 1, minWidth: '150px' }}
            />
            <span style={{ minWidth: '70px', fontWeight: 'bold' }}>{streamMedia.videoBitrate || 1500}k</span>
          </label>
          <p className="hint" style={{ marginTop: '0.5rem', fontSize: '0.8rem' }}>
            Önerilen: 360p için 1000k, 480p için 1500k, 720p için 2500k, 1080p için 4500k
          </p>
        </div>

        {/* Publish Button */}
        <div style={{ marginTop: '1.5rem', textAlign: 'center' }}>
          <button
            onClick={handlePublishStream}
            className="start-btn"
            disabled={!streamMedia.activeMediaId}
            style={{ fontSize: '1.1rem', padding: '12px 30px' }}
          >
            {youtubeStreamState.isStreaming ? 'Yeni Ayarlarla Yayınla' : 'Yayınla'}
          </button>
          <p className="hint" style={{ marginTop: '0.5rem', fontSize: '0.85rem' }}>
            {youtubeStreamState.isStreaming
              ? 'Yayını durdurup yeni görsel/video ve bitrate ile yeniden başlatır.'
              : 'Seçilen görsel/video ve bitrate ayarlarıyla YouTube yayını başlatır.'}
          </p>
        </div>

        <p className="hint" style={{ marginTop: '1rem' }}>
          Görsel seçilirse statik olarak gösterilir. Video seçilirse sürekli tekrar eder.
          YouTube yayını aktifken değişiklik sonraki başlatmada etkili olur.
        </p>
          </>
        )}
      </section>

      {/* Upload */}
      <section className="section">
        <h2>MP3 Yükle</h2>
        <div className="upload-area">
          <input
            type="file"
            accept=".mp3,audio/mpeg"
            onChange={handleUpload}
            disabled={uploading}
            id="file-upload"
            style={{ display: 'none' }}
          />
          <label htmlFor="file-upload" className={`upload-button ${uploading ? 'disabled' : ''}`}>
            {uploading ? 'Yükleniyor...' : '📁 Dosya Seç'}
          </label>

          {uploading && (
            <div className="upload-progress-container">
              <div className="upload-file-name">{uploadFileName}</div>
              <div className="progress-bar">
                <div
                  className="progress-fill"
                  style={{ width: `${uploadProgress}%` }}
                />
              </div>
              <div className="progress-text">{uploadProgress}%</div>
            </div>
          )}
        </div>
      </section>

      {/* Playlist */}
      <section className="section">
        <div className="playlist-header">
          <h2>Oynatma Listesi ({playlist.length})</h2>
          <button
            onClick={shufflePlaylist}
            className="shuffle-btn"
            disabled={playlist.length < 2}
            title="Listeyi karıştır"
          >
            🔀 Karıştır
          </button>
        </div>
        <div className="playlist-info">
          <span className="hint">Yayın bu listedeki parçaları sırayla çalacak • Son parçadan sonra otomatik karışır</span>
          <span className="total-duration">Toplam Süre: {formatTotalDuration(totalPlaylistDuration)}</span>
        </div>
        <div className="playlist">
          {playlist.map((track, index) => (
            <div
              key={track.id}
              className={`playlist-item ${radioState.currentTrack?.id === track.id ? 'now-playing' : ''}`}
            >
              <span className="track-number">{index + 1}.</span>
              <div className="playlist-track-info">
                <span className="track-name">
                  {track.name}
                  {radioState.currentTrack?.id === track.id && ' 🔊'}
                </span>
                <div className="playlist-track-meta">
                  {track.reader && <span className="reader-name">📖 {track.reader}</span>}
                  {track.description && <span className="track-desc-short">📝 {track.description}</span>}
                </div>
              </div>
              <span className="track-duration">{formatDuration(track.duration)}</span>
              <div className="track-actions">
                <button onClick={() => startEditTrack(track)} title="Düzenle" className="edit-btn">✏️</button>
                <button onClick={() => moveInPlaylist(index, -1)} disabled={index === 0}>↑</button>
                <button onClick={() => moveInPlaylist(index, 1)} disabled={index === playlist.length - 1}>↓</button>
                <button onClick={() => playTrack(track.id)} title="Bu parçayı çal">▶</button>
                {renderDownloadButton('tracks', track)}
                <button onClick={() => removeFromPlaylist(track.id)} className="danger">×</button>
              </div>
            </div>
          ))}
          {playlist.length === 0 && <p>Playlist boş. Aşağıdan dosya ekleyin.</p>}
        </div>
      </section>

      {/* All Tracks */}
      <section className="section">
        <h2>Tüm Dosyalar ({tracks.length})</h2>
        <div className="playlist-info">
          <span className="hint">Yüklenen tüm ses dosyaları</span>
          <span className="total-duration">Toplam Boyut: {formatSize(totalTracksSize)}</span>
        </div>
        <div className="track-list">
          {tracks.map(track => {
            const inPlaylist = playlist.some(p => p.id === track.id);
            return (
              <div key={track.id} className="track-item">
                <div className="track-info">
                  <span className="track-name">{track.name}</span>
                  <div className="track-reader-desc">
                    {track.reader && <span className="reader-name">📖 {track.reader}</span>}
                    {track.description && <span className="track-description">📝 {track.description}</span>}
                    {!track.reader && !track.description && <span className="no-info">Bilgi eklenmemiş</span>}
                  </div>
                  <div className="track-meta">
                    <span className="meta-item" title="Süre">🕐 {formatDuration(track.duration)}</span>
                    <span className="meta-item" title="Boyut">📦 {formatSize(track.size)}</span>
                    <span className="meta-item" title="Tip">🎵 MP3</span>
                  </div>
                </div>
                <div className="track-actions">
                  <button onClick={() => startEditTrack(track)} title="Düzenle" className="edit-btn">✏️</button>
                  {!inPlaylist ? (
                    <button onClick={() => addToPlaylist(track.id)} title="Listeye Ekle">+ Ekle</button>
                  ) : (
                    <span className="in-playlist">✓ Listede</span>
                  )}
                  {renderDownloadButton('tracks', track)}
                  <button onClick={() => deleteTrack(track.id)} title="Sil" className="danger">×</button>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* Bağlantılar */}
      <section className="section">
        <h2 className="section-toggle" onClick={() => setLinksOpen(!linksOpen)}>
          <span className={`toggle-arrow ${linksOpen ? 'open' : ''}`}>▶</span>
          Bağlantılar ({links.length})
        </h2>
        {linksOpen && (
        <>
        <p className="hint">Dinleyicilere gösterilecek sosyal medya ve diğer bağlantılar</p>

        {/* Yeni Bağlantı Ekle */}
        <div className="link-add-form">
          <div className="link-form-row">
            <input
              type="text"
              placeholder="Bağlantı Adı (örn: YouTube)"
              value={newLinkName}
              onChange={(e) => setNewLinkName(e.target.value)}
            />
            <input
              type="url"
              placeholder="URL (https://...)"
              value={newLinkUrl}
              onChange={(e) => setNewLinkUrl(e.target.value)}
            />
          </div>
          <div className="link-form-row">
            <div className="icon-select-wrapper">
              <select
                value={newLinkIconId}
                onChange={(e) => {
                  setNewLinkIconId(e.target.value);
                  if (e.target.value) setNewLinkCustomIcon(null);
                }}
                className="icon-select"
                disabled={newLinkCustomIcon}
              >
                <option value="">Hazır Icon Seç...</option>
                {PREDEFINED_ICONS.map(icon => (
                  <option key={icon.id} value={icon.id}>{icon.name}</option>
                ))}
              </select>
              {newLinkIconId && !newLinkCustomIcon && (
                <span
                  className="icon-preview"
                  dangerouslySetInnerHTML={{ __html: getIconById(newLinkIconId)?.svg }}
                />
              )}
            </div>
            <span className="icon-or">veya</span>
            <label className="custom-icon-upload">
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  if (e.target.files[0]) {
                    setNewLinkCustomIcon(e.target.files[0]);
                    setNewLinkIconId('');
                  }
                }}
                style={{ display: 'none' }}
              />
              <span className={`custom-icon-btn ${newLinkCustomIcon ? 'has-file' : ''}`}>
                {newLinkCustomIcon ? `✓ ${newLinkCustomIcon.name.slice(0, 15)}...` : '📷 Özel Icon'}
              </span>
            </label>
            {newLinkCustomIcon && (
              <button
                type="button"
                className="clear-icon-btn"
                onClick={() => setNewLinkCustomIcon(null)}
              >×</button>
            )}
            <button onClick={addLink} className="add-link-btn">+ Ekle</button>
          </div>
        </div>

        {/* Bağlantı Listesi */}
        <div className="links-list">
          {links.map((link, index) => {
            const iconData = getIconById(link.iconId);
            return (
              <div key={link.id} className="link-item">
                <div className="link-icon">
                  {link.customIcon ? (
                    <img src={`${BASE_URL}/icons/${link.customIcon}`} alt={link.name} />
                  ) : iconData ? (
                    <span dangerouslySetInnerHTML={{ __html: iconData.svg }} />
                  ) : (
                    <span className="default-icon">🔗</span>
                  )}
                </div>
                <div className="link-info">
                  <span className="link-name">{link.name}</span>
                  <span className="link-url">{link.url}</span>
                </div>
                <div className="link-actions">
                  <button onClick={() => moveLinkInList(index, -1)} disabled={index === 0} title="Yukarı">↑</button>
                  <button onClick={() => moveLinkInList(index, 1)} disabled={index === links.length - 1} title="Aşağı">↓</button>
                  <button onClick={() => startEditLink(link)} className="edit-btn">✏️</button>
                  <button onClick={() => deleteLink(link.id)} className="danger">×</button>
                </div>
              </div>
            );
          })}
          {links.length === 0 && <p className="hint">Henüz bağlantı eklenmemiş.</p>}
        </div>
        </>
        )}
      </section>

      {/* Slayt Resimleri */}
      <section className="section">
        <h2 className="section-toggle" onClick={() => setSlidesOpen(!slidesOpen)}>
          <span className={`toggle-arrow ${slidesOpen ? 'open' : ''}`}>▶</span>
          Slayt Resimleri ({slides.length})
        </h2>
        {slidesOpen && (
        <>
        <p className="hint">Dinleyiciler resim modunda bu resimleri tam ekran olarak görebilir (30 sn aralıkla değişir)</p>

        {/* Resim Yükleme */}
        <div className="slide-upload-area">
          <label className={`upload-button ${uploadingSlide ? 'disabled' : ''}`}>
            <input
              type="file"
              accept="image/jpeg,image/png,image/webp"
              onChange={handleSlideUpload}
              disabled={uploadingSlide}
              multiple
              style={{ display: 'none' }}
            />
            {uploadingSlide
              ? `Yükleniyor... (${slideUploadProgress.current}/${slideUploadProgress.total})`
              : '📷 Resim Yükle'}
          </label>
          <span className="upload-hint">JPG, PNG veya WEBP - Birden fazla seçebilirsiniz (max 20MB/dosya)</span>
        </div>

        {/* Resim Listesi */}
        <div className="slides-list">
          {slides.map(slide => (
            <div key={slide.id} className="slide-item">
              <div className="slide-preview">
                <img src={`${BASE_URL}/slides/${slide.filename}`} alt={slide.originalName} />
              </div>
              <div className="slide-info">
                <span className="slide-name">{slide.originalName}</span>
                <div className="slide-meta">
                  <span>{slide.width}x{slide.height} px</span>
                  <span>{formatSize(slide.size)}</span>
                </div>
              </div>
              <div className="slide-actions">
                <button onClick={() => deleteSlide(slide.id)} className="danger">×</button>
              </div>
            </div>
          ))}
          {slides.length === 0 && <p className="hint">Henüz resim yüklenmemiş.</p>}
        </div>
        </>
        )}
      </section>

      {/* Okuyanlar */}
      <section className="section">
        <h2 className="section-toggle" onClick={() => setReadersOpen(!readersOpen)}>
          <span className={`toggle-arrow ${readersOpen ? 'open' : ''}`}>▶</span>
          Okuyanlar ({readers.length})
        </h2>
        {readersOpen && (
        <>
        <p className="hint">Risale-i Nur okuyanların listesi - Dinleyiciler bağlantılar bölümünden görebilir</p>

        {/* Yeni Okuyan Ekle */}
        <div className="link-add-form">
          <div className="link-form-row">
            <input
              type="text"
              placeholder="Okuyan Adı (örn: Mehmet Fırıncı)"
              value={newReaderName}
              onChange={(e) => setNewReaderName(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && addReader()}
              style={{ flex: 2 }}
            />
            <button onClick={addReader} className="add-link-btn">+ Ekle</button>
          </div>
        </div>

        {/* Okuyanlar Listesi */}
        <div className="links-list">
          {readers.map((reader, index) => (
            <div key={reader.id} className="link-item">
              <div className="link-icon" style={{ background: 'rgba(76, 175, 80, 0.2)' }}>
                <span style={{ fontSize: '1.2rem' }}>📖</span>
              </div>
              <div className="link-info">
                <span className="link-name">{reader.name}</span>
              </div>
              <div className="link-actions">
                <button onClick={() => moveReaderInList(index, -1)} disabled={index === 0} title="Yukarı">↑</button>
                <button onClick={() => moveReaderInList(index, 1)} disabled={index === readers.length - 1} title="Aşağı">↓</button>
                <button onClick={() => deleteReader(reader.id)} className="danger">×</button>
              </div>
            </div>
          ))}
          {readers.length === 0 && <p className="hint">Henüz okuyan eklenmemiş.</p>}
        </div>
        </>
        )}
      </section>

      {/* Hakkında */}
      <section className="section">
        <h2 className="section-toggle" onClick={() => setAboutOpen(!aboutOpen)}>
          <span className={`toggle-arrow ${aboutOpen ? 'open' : ''}`}>▶</span>
          Hakkında Metni
        </h2>
        {aboutOpen && (
        <>
        <p className="hint">Dinleyicilere gösterilecek "Hakkında" bilgisi</p>

        <div className="about-edit-area">
          <textarea
            placeholder="Radyo hakkında bilgi yazın... (Markdown desteklenmez, düz metin)"
            value={aboutText}
            onChange={(e) => setAboutText(e.target.value)}
            rows={6}
            style={{
              width: '100%',
              padding: '1rem',
              background: 'rgba(255, 255, 255, 0.1)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              borderRadius: '10px',
              color: '#fff',
              fontSize: '1rem',
              resize: 'vertical',
              minHeight: '120px',
              marginBottom: '1rem'
            }}
          />
          <button
            onClick={saveAbout}
            disabled={aboutSaving}
            className="add-link-btn"
          >
            {aboutSaving ? 'Kaydediliyor...' : 'Kaydet'}
          </button>
        </div>
        </>
        )}
      </section>

      {/* Duyuru */}
      <section className="section">
        <h2 className="section-toggle" onClick={() => setAnnouncementOpen(!announcementOpen)}>
          <span className={`toggle-arrow ${announcementOpen ? 'open' : ''}`}>▶</span>
          Duyurular ({announcements.length})
        </h2>
        {announcementOpen && (() => {
          // Sıradaki çalınacak (aktif) duyurunun index'i
          let nextPlayableIndex = -1;
          for (let i = 0; i < announcements.length; i++) {
            const idx = (announcementMeta.nextIndex + i) % announcements.length;
            if (announcements[idx].enabled !== false) { nextPlayableIndex = idx; break; }
          }
          return (
        <>
        <p className="hint">
          Duyurular listedeki sırayla, her {announcementInterval} parçada bir çalınır. Pasif duyurular atlanır.
          {nextPlayableIndex >= 0 && announcementMeta.tracksUntilNext !== null && radioState.isPlaying &&
            ` Sıradaki duyuruya ${announcementMeta.tracksUntilNext} parça kaldı.`}
        </p>

        {/* Aralık ayarı */}
        <div className="link-add-form">
          <div className="link-form-row" style={{ alignItems: 'center' }}>
            <span style={{ whiteSpace: 'nowrap' }}>Kaç parçada bir:</span>
            <input
              type="number"
              min="1"
              max="1000"
              value={announcementIntervalInput}
              onChange={(e) => setAnnouncementIntervalInput(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && saveAnnouncementInterval()}
              style={{ flex: 1, maxWidth: '120px' }}
            />
            <button
              onClick={saveAnnouncementInterval}
              className="add-link-btn"
              disabled={String(announcementInterval) === announcementIntervalInput}
            >
              Kaydet
            </button>
          </div>
        </div>

        {/* Yeni duyuru ekle */}
        <div className="link-add-form">
          <div className="link-form-row">
            <input
              type="text"
              placeholder="Duyuru adı (boş bırakılırsa dosya adı kullanılır)"
              value={newAnnouncementName}
              onChange={(e) => setNewAnnouncementName(e.target.value)}
              style={{ flex: 2 }}
            />
            <label className={`upload-button ${uploadingAnnouncement ? 'disabled' : ''}`} style={{ margin: 0 }}>
              <input
                type="file"
                accept="audio/mp3,audio/mpeg"
                multiple
                onChange={uploadAnnouncements}
                disabled={uploadingAnnouncement}
                style={{ display: 'none' }}
              />
              {uploadingAnnouncement ? 'Yükleniyor...' : '+ MP3 Ekle'}
            </label>
          </div>
        </div>

        {/* Duyuru listesi */}
        <div className="links-list">
          {announcements.map((item, index) => {
            const isEnabled = item.enabled !== false;
            const isEditing = editingAnnouncementId === item.id;
            return (
              <div key={item.id} className="link-item" style={{ opacity: isEnabled ? 1 : 0.5 }}>
                <div className="link-icon" style={{ background: 'rgba(255, 152, 0, 0.2)' }}>
                  <span style={{ fontSize: '1.2rem' }}>📢</span>
                </div>
                <div className="link-info">
                  {isEditing ? (
                    <input
                      type="text"
                      value={editingAnnouncementName}
                      autoFocus
                      onChange={(e) => setEditingAnnouncementName(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') saveAnnouncementName();
                        if (e.key === 'Escape') setEditingAnnouncementId(null);
                      }}
                    />
                  ) : (
                    <span className="link-name">
                      {index + 1}. {item.name}
                      {index === nextPlayableIndex && (
                        <span style={{ marginLeft: '0.5rem', fontSize: '0.75rem', color: '#ff9800' }}>• Sıradaki</span>
                      )}
                      {!isEnabled && (
                        <span style={{ marginLeft: '0.5rem', fontSize: '0.75rem' }}>(pasif)</span>
                      )}
                    </span>
                  )}
                  <span className="link-url">
                    {item.duration ? `${formatDuration(item.duration)} · ` : ''}{formatSize(item.size)}
                  </span>
                </div>
                <div className="link-actions">
                  {isEditing ? (
                    <>
                      <button onClick={saveAnnouncementName} title="Kaydet">✓</button>
                      <button onClick={() => setEditingAnnouncementId(null)} title="İptal">✕</button>
                    </>
                  ) : (
                    <>
                      <button onClick={() => moveAnnouncement(index, -1)} disabled={index === 0} title="Yukarı">↑</button>
                      <button onClick={() => moveAnnouncement(index, 1)} disabled={index === announcements.length - 1} title="Aşağı">↓</button>
                      <button
                        onClick={() => updateAnnouncement(item.id, { enabled: !isEnabled }, isEnabled ? 'Duyuru pasif yapıldı' : 'Duyuru aktif yapıldı')}
                        title={isEnabled ? 'Pasif yap' : 'Aktif yap'}
                      >
                        {isEnabled ? '⏸' : '▶'}
                      </button>
                      <button
                        onClick={() => { setEditingAnnouncementId(item.id); setEditingAnnouncementName(item.name); }}
                        title="Adı düzenle"
                      >
                        ✎
                      </button>
                      <label
                        className={`upload-button ${uploadingAnnouncement ? 'disabled' : ''}`}
                        title="Ses dosyasını değiştir"
                        style={{ margin: 0, padding: '0.3rem 0.6rem' }}
                      >
                        <input
                          type="file"
                          accept="audio/mp3,audio/mpeg"
                          onChange={(e) => replaceAnnouncementFile(item.id, e)}
                          disabled={uploadingAnnouncement}
                          style={{ display: 'none' }}
                        />
                        🔁
                      </label>
                      {renderDownloadButton('announcements', item)}
                      <button onClick={() => deleteAnnouncement(item)} className="danger" title="Sil">×</button>
                    </>
                  )}
                </div>
              </div>
            );
          })}
          {announcements.length === 0 && (
            <p className="hint" style={{ color: 'rgba(255, 152, 0, 0.8)' }}>Henüz duyuru eklenmemiş</p>
          )}
        </div>
        </>
          );
        })()}
      </section>

      {/* Geçiş Sesleri */}
      <section className="section">
        <h2 className="section-toggle" onClick={() => setJinglesOpen(!jinglesOpen)}>
          <span className={`toggle-arrow ${jinglesOpen ? 'open' : ''}`}>▶</span>
          Parçalar Arası Geçiş Sesi
          <span style={{
            marginLeft: '0.75rem',
            fontSize: '0.75rem',
            padding: '0.15rem 0.6rem',
            borderRadius: '999px',
            background: jinglesEnabled ? 'rgba(76, 175, 80, 0.25)' : 'rgba(255, 255, 255, 0.1)',
            color: jinglesEnabled ? '#81c784' : 'rgba(255, 255, 255, 0.6)'
          }}>
            {jinglesEnabled ? 'Açık' : 'Kapalı'}
          </span>
        </h2>
        {jinglesOpen && (
        <>
        <p className="hint">
          Açıkken her parça bittiğinde, sonraki parçadan önce buradaki kısa seslerden biri çalınır.
          Birden fazla ses varsa sırayla çalınır. Duyuru zamanı geldiyse sıra: duyuru → geçiş sesi → parça.
        </p>

        <div className="link-add-form">
          <div className="link-form-row" style={{ alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
            <button
              onClick={toggleJinglesEnabled}
              className="add-link-btn"
              style={{ background: jinglesEnabled ? '#c62828' : '#2e7d32' }}
            >
              {jinglesEnabled ? 'Geçiş Seslerini Kapat' : 'Geçiş Seslerini Aç'}
            </button>
            <label className={`upload-button ${uploadingJingle ? 'disabled' : ''}`} style={{ margin: 0 }}>
              <input
                type="file"
                accept="audio/mp3,audio/mpeg"
                multiple
                onChange={uploadJingles}
                disabled={uploadingJingle}
                style={{ display: 'none' }}
              />
              {uploadingJingle ? 'Yükleniyor...' : '+ Kısa Ses Ekle (MP3)'}
            </label>
          </div>
          {jinglesEnabled && jingles.filter(j => j.enabled !== false).length === 0 && (
            <p className="hint" style={{ color: 'rgba(255, 152, 0, 0.9)', marginTop: '0.5rem' }}>
              Geçiş sesleri açık ama çalınabilecek (aktif) ses yok.
            </p>
          )}
        </div>

        <div className="links-list">
          {jingles.map((item, index) => {
            const isEnabled = item.enabled !== false;
            return (
              <div key={item.id} className="link-item" style={{ opacity: isEnabled ? 1 : 0.5 }}>
                <div className="link-icon" style={{ background: 'rgba(33, 150, 243, 0.2)' }}>
                  <span style={{ fontSize: '1.2rem' }}>🔔</span>
                </div>
                <div className="link-info">
                  <span className="link-name">
                    {index + 1}. {item.name}
                    {!isEnabled && <span style={{ marginLeft: '0.5rem', fontSize: '0.75rem' }}>(pasif)</span>}
                  </span>
                  <span className="link-url">
                    {item.duration ? `${formatDuration(item.duration)} · ` : ''}{formatSize(item.size)}
                  </span>
                </div>
                <div className="link-actions">
                  <button
                    onClick={() => updateJingle(item.id, { enabled: !isEnabled })}
                    title={isEnabled ? 'Pasif yap' : 'Aktif yap'}
                  >
                    {isEnabled ? '⏸' : '▶'}
                  </button>
                  <button onClick={() => renameJingle(item)} title="Adı düzenle">✎</button>
                  {renderDownloadButton('jingles', item)}
                  <button onClick={() => deleteJingle(item)} className="danger" title="Sil">×</button>
                </div>
              </div>
            );
          })}
          {jingles.length === 0 && <p className="hint">Henüz geçiş sesi eklenmemiş.</p>}
        </div>
        </>
        )}
      </section>

      {/* Güvenlik */}
      <section className="section">
        <h2 className="section-toggle" onClick={() => setSecurityOpen(!securityOpen)}>
          <span className={`toggle-arrow ${securityOpen ? 'open' : ''}`}>▶</span>
          Güvenlik / Parola Değiştir
        </h2>
        {securityOpen && (
          <>
            <p className="hint">
              Parola değiştirildiğinde diğer cihazlardaki tüm oturumlar kapatılır.
              5 hatalı giriş denemesinden sonra ilgili IP adresi geçici olarak engellenir.
            </p>
            <ChangePasswordForm
              onSuccess={() => {
                showNotification('Parola değiştirildi. Diğer oturumlar kapatıldı.', 'success');
                setSecurityOpen(false);
              }}
              onUnauthorized={handleLogout}
            />
          </>
        )}
      </section>

      {/* Link Edit Modal */}
      {editingLink && (
        <div className="modal-overlay" onClick={cancelEditLink}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Bağlantı Düzenle</h3>
            <div className="modal-field">
              <label>Bağlantı Adı:</label>
              <input
                type="text"
                value={editLinkName}
                onChange={(e) => setEditLinkName(e.target.value)}
              />
            </div>
            <div className="modal-field">
              <label>URL:</label>
              <input
                type="url"
                value={editLinkUrl}
                onChange={(e) => setEditLinkUrl(e.target.value)}
              />
            </div>
            <div className="modal-field">
              <label>Icon:</label>
              <div className="icon-edit-options">
                {/* Mevcut Icon Gösterimi */}
                {(editingLink.customIcon || editingLink.iconId) && !editLinkCustomIcon && (
                  <div className="current-icon-display">
                    <span>Mevcut:</span>
                    {editingLink.customIcon ? (
                      <img src={`${BASE_URL}/icons/${editingLink.customIcon}`} alt="Mevcut icon" className="current-icon-img" />
                    ) : (
                      <span className="current-icon-svg" dangerouslySetInnerHTML={{ __html: getIconById(editingLink.iconId)?.svg }} />
                    )}
                  </div>
                )}
                <div className="icon-select-wrapper">
                  <select
                    value={editLinkIconId}
                    onChange={(e) => {
                      setEditLinkIconId(e.target.value);
                      if (e.target.value) setEditLinkCustomIcon(null);
                    }}
                    className="icon-select"
                    disabled={editLinkCustomIcon}
                  >
                    <option value="">Hazır Icon Seç...</option>
                    {PREDEFINED_ICONS.map(icon => (
                      <option key={icon.id} value={icon.id}>{icon.name}</option>
                    ))}
                  </select>
                  {editLinkIconId && !editLinkCustomIcon && (
                    <span
                      className="icon-preview"
                      dangerouslySetInnerHTML={{ __html: getIconById(editLinkIconId)?.svg }}
                    />
                  )}
                </div>
                <span className="icon-or">veya</span>
                <label className="custom-icon-upload">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      if (e.target.files[0]) {
                        setEditLinkCustomIcon(e.target.files[0]);
                        setEditLinkIconId('');
                      }
                    }}
                    style={{ display: 'none' }}
                  />
                  <span className={`custom-icon-btn ${editLinkCustomIcon ? 'has-file' : ''}`}>
                    {editLinkCustomIcon ? `✓ ${editLinkCustomIcon.name.slice(0, 15)}...` : '📷 Özel Icon'}
                  </span>
                </label>
                {editLinkCustomIcon && (
                  <button
                    type="button"
                    className="clear-icon-btn"
                    onClick={() => setEditLinkCustomIcon(null)}
                  >×</button>
                )}
              </div>
            </div>
            <div className="modal-actions">
              <button onClick={cancelEditLink} className="cancel-btn">İptal</button>
              <button onClick={saveEditLink} className="save-btn">Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Admin;
